/**
 * 获取当前id的完整路径的信息
 * @param {object} cascader - element ui cascader options
 * @param {number} id - last child node value
 * @returns {Array} - full value for cascader show
 *
 */
export function getCascaderFullValue(cascader, id) {
  //如果id已经是数组,那就证明这个数据已经是完整的路径了,不需要计算了
  if (Array.isArray(id)) {
    return id
  }
  //最后一个结点的id值
  let cascaderFullValue = [id];
  _getParentId(cascaderFullValue, cascader, cascader, id);

  return cascaderFullValue;

  /**
   *
   * 获取父节点的信息
   * @param {Array} cascaderFullValue value for return
   * @param {Array} cascader value for loop
   * @param {Array} _cascader value of original
   * @param {number} _id  value of bottom item
   */
  function _getParentId(cascaderFullValue, cascader, _cascader, _id) {
    //如果不是一个数组,停止计算,避免报错
    if (!Array.isArray(cascader)) return;

    for (let cascaderItem of cascader) {
      //结束当前循环,进入下一个循环,
      if (!Array.isArray(cascaderItem.children)) continue;

      let index = cascaderItem.children.findIndex(item => {
        return item.value === _id
      });
      if (index >= 0) {
        cascaderFullValue.unshift(cascaderItem.value);

        if (_cascader.findIndex(item => item.value === cascaderItem.value) < 0) //is original item
          _getParentId(cascaderFullValue, _cascader, _cascader, cascaderItem.value);
      } else {
        //递归查询
        _getParentId(cascaderFullValue, cascaderItem.children, _cascader, _id);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/cascader.js